import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import React, { useEffect, useRef, useState } from "react";

// import Paper from "@mui/material/Paper";
import { useAuth0 } from "@auth0/auth0-react";
import { CircularProgress } from "@material-ui/core";
import AuthService from "Lib/API/Auth";
import FinanceService from "Lib/API/Finance";
import ReportService from "Lib/API/Report";
import { ReactComponent as FaveFalse } from "assets/icons/FavFalse.svg";
import { ReactComponent as FaveTrue } from "assets/icons/FavTrue.svg";
import { ReactComponent as Sort } from "assets/icons/Sort.svg";
import Action from "components/ActionPopOver";
import AlertDialog from "components/Dialog";
import InfoTooltip from "components/InfoTooltip";
import NewDialog from "components/NewDialog/Dialog";
import Button from "components/button/Button";
import Loader from "components/loader/Loader";
import { formatDate } from "helper/dateFormat.js";
import { resolveFieldValueForExport } from "pages/Members/NewFilter/resolveFieldValue";
import { toastr } from "react-redux-toastr";
import { useReactToPrint } from "react-to-print";
import styled from "styled-components";
import * as XLSX from "xlsx";
import { sanitizeRows } from "utils/exportSanitize";
import { DateFormetContext } from "../../../app/App.js";
import MyModal from "../../../components/MyModal";
import "../../NewFinance/index.scss";
import "../index.scss";
import Report from "../modals/report";
const ReportHeadRow = styled(TableRow)`
  background: #f3f6f9;
  border: none;
`;
const ReportTableRow = styled(TableRow)`
  background: #ffffff;
  border: none;
`;
const SpanHeader = styled.span`
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #4d5565;
  opacity: 1;
  font-family: var(--ReportsSpanHeaderFont-family);
`;

const ReportButton = styled.span`
  color: #2555ef !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 18px !important;
  text-transform: uppercase !important;
  cursor: default !important;
  height: 25px;
  display: flex;
  width: max-content;
  align-items: center;
`;
const SpanReport = styled.span`
  color: #4f4f4f;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  font-family: var(--ReportsSpanReportFont-family);
  display: flex;
  align-items: center;
`;
const SpanNameReport = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  font-family: var(--ReportsSpanNameReportFont-family);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  color: #4f4f4f;
  > span {
    color: #acacac;
    font-family: var(--ReportsSpanNameReportSpanFont-family);
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 32px;
    align-self: flex-start;
  }
`;
const SpanSubReport = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 32px;
  color: #acacac;
`;
const TimeWrap = styled.div`
  display: flex;
  flex-direction: column;
`;
const SortSvg = styled(Sort)`
  margin-left: 10px;
  cursor: pointer;
  margin-bottom: 4px;
`;
const FaveFalseSvg = styled(FaveFalse)`
  cursor: pointer;
`;
const FaveTrueSvg = styled(FaveTrue)`
  cursor: pointer;
`;
const Box = styled.div`
  display: flex;
  flex-direction: column;
`;
export const TableReport = ({
  setId,
  selectedId,
  isLoading,
  favLoading,
  deleteLoading,
  publicLoading,
  setDuolicatetData,
  setDuolicatetModal,
  deleteFilter,
  filters,
  sortReport,
  data,
  onChange,
  onFave,
  page,
  count,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  toggle,
  financialReports,
  setFinancialReports,
  getReports,
}) => {
  const dateFormet = React.useContext(DateFormetContext);
  const { getAccessTokenSilently } = useAuth0();
  const [Data, setData] = React.useState([]);
  const [openReport, setOpenReport] = useState(false);
  const [reportType, setReportType] = useState(false);
  const [reportIndex, setReportIndex] = useState(false);
  const [reportName, setReportName] = useState('');
  const [confirmClose, setConfirmClose] = useState(false);
  
  const generateExcel = (data) => {
    const resultData = data?.map(({ tags, account, ...rest }) => {
      return {
        ...rest,
      };
    });
    const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(resultData));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(
      workbook,
      localStorage.getItem("organization")
        ? JSON.parse(
            localStorage.getItem("organization")
          )?.orgName?.toString() + ".xlsx"
        : "DataSheet.xlsx"
    );
  };

  const handleRunReport = async (type, index,name) => {
    if (toggle == "Financial Reports") {
      setOpenReport(true);
    }
    setReportType(type);
    setReportIndex(index);
    setReportName(name)
  };
  const handleDownload = async (id) => {
    let resultData = [];
    const token = await getAccessTokenSilently();
    await AuthService.getFilterById(id, token)
      .then((res) => {
        resultData = res?.selectedFieldsOrder;
      })
      .catch((err) => toastr.error("Error", err?.data?.message));
    await FinanceService.getDataFilterForEditById(id, token)
      .then((res) => {
        if (res?.length > 0) {
          const result = res.map((item) => {
            const resultObj = {};
            // eslint-disable-next-line no-unused-expressions
            resultData?.forEach((column) => {
              resultObj[column.displayName] = resolveFieldValueForExport(item, column);
            });
            return resultObj;
          });
          generateExcel(result);
        } else {
          toastr.error("Error", "You can not download the empty report.");
        }
      })
      .catch((err) => toastr.error("Error", err?.data?.message));
  };
  const handleDownloadPdf = async (id) => {
    let resultData = [];
    const token = await getAccessTokenSilently();
    await AuthService.getFilterById(id, token)
      .then((res) => {
        resultData = res?.selectedFieldsOrder;
      })
      .catch((err) => err);
    await FinanceService.getDataFilterForEditById(id, token)
      .then((res) => {
        const result = res?.map((item) => {
          const resultObj = {};
          // eslint-disable-next-line no-unused-expressions
          resultData?.forEach((column) => {
            resultObj[column.displayName] = resolveFieldValueForExport(item, column);
          });
          if (item?.account?.mailLabelName) {
            resultObj["Mail Label Name"] = item.account.mailLabelName;
          }
          return resultObj;
        });
        setData(result);
      })
      .catch((error) => {
        toastr.error("Error", error?.data?.message);
      });
  };
  const componentRef = useRef();
  useEffect(() => {
    handlePrint();
  }, [Data]);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  let newData = Data?.map((item) => {
    return {
      ...item,
      ...item?.payment,
      id: item?._id,
      ...(item?.country && {
        ["country"]: item.addresses?.map((item) => {
          return item?.country;
        })[0],
      }),
      ...(item?.payment?.account_type && {
        ["account_type"]: item?.payment?.account_type,
      }),
      ...(item?.addresses?.map((item) => {
        return item?.zip_code;
      })[0] !== undefined && {
        ["zip_code"]: item?.addresses?.map((item) => {
          return item?.zip_code;
        })[0],
      }),
      ...(item?.addresses?.map((item) => {
        return item?.neighborhood;
      })[0] !== undefined && {
        ["neighborhood"]: item?.addresses?.map((item) => {
          return item?.neighborhood;
        })[0],
      }),
      ...(item?.addresses?.map((item) => {
        return item?.country;
      })[0] !== undefined && {
        ["country"]: item?.addresses?.map((item) => {
          return item?.country;
        })[0],
      }),
      ...(item?.addresses?.map((item) => {
        return item?.location?.formattedAddress;
      })[0] !== undefined && {
        ["formattedAddress"]: item?.addresses
          ?.map((item) => {
            return item?.location?.formattedAddress;
          })[0]
          ?.split(",")[0],
      }),
      ...(item?.addresses?.map((item) => {
        return item?.city;
      })[0] !== undefined && {
        ["city"]: item?.addresses?.map((item) => {
          return item?.city;
        })[0],
      }),
      ...(item?.addresses?.map((item) => {
        return item?.state;
      })[0] !== undefined && {
        ["state"]: item?.addresses?.map((item) => {
          return item?.state;
        })[0],
      }),
      ...(item?.old_account_id && {
        ["old_account_id"]: item?.old_account_id,
      }),
      ...(item?.payment?.account_sub_type?.title && {
        ["category"]: item?.payment?.account_sub_type?.title,
      }),
    };
  });


  let printingKeys = Object.keys(
    Data.reduce(function (result, obj) {
      return Object.assign(result, obj);
    }, {})
  );
  const ComponentToPrint = () => {
    return (
      <table ref={componentRef}>
        <thead>
          {printingKeys
            ?.filter((item) => item !== "account" && item !== "tags")
            ?.map((column) => (
              <th style={{ border: "1px solid" }}>{column}</th>
            ))}
        </thead>
        <tbody>
          {Data?.map((datas) => (
            <tr style={{ border: "1px solid black" }}>
              {printingKeys
                ?.filter((item) => item !== "tags" && item !== "account")
                ?.map((objectKey, index) => (
                  <td
                    style={{
                      borderRight: "1px solid black ",
                      borderLeft: "1px solid black",
                    }}
                    key={index}
                  >
                    {/* {objectKey} */}
                    {datas?.[objectKey]}
                  </td>
                ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const getFinancialList = async () => {
    const token = await getAccessTokenSilently();
    const body = {
      type: "financial",
      search: filters?.search ?? "",
    };

    if (body.search === "") {
      delete body.search;
    }

    await ReportService.getFinancialList(token, body)
      .then((res) => {
        const result = res?.payload?.data;
        setFinancialReports([...result]);
        // setFinancialReports([...result?.slice(0,7)?.reverse(),result[7],result[8]]);

      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };

  useEffect(() => {
    if (toggle === "Financial Reports") {
      getFinancialList();
    }
  }, [filters.search]);

  useEffect(() => {
    localStorage.setItem("goto", "parameter");
  }, []);

  const reportTitle = ()=>{
    switch (reportIndex) {
      case 0:
        return "Aged account receivable summarized by Ledger"

      case 1:
        return "Aged account receivable summarized by Family"

      case 2:
        return "Billing Summarized by Ledger"

      case 3:
        return "Batch details"

      case 4:
        return "Ledger report"
      case 5 :
        return "Ledger account summary"
      case 6:
        return "Billing Report by Account (Family)"
      case 7:
        return "Billing Report by Ledger"
      case 8:
        return "Payment by payment method type"
      case 9:
        return "Credit on Account"
      default: return ""
    }
  }

  const closeModal = () => {
    setOpenReport(false);
    getFinancialList();
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setOpenReport(false);
    getFinancialList();
  }

  return (
    <Box>
      {isLoading ? (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          <Loader />
        </div>
      ) : (
        <TableContainer classes="mt-5" className={toggle !== "Financial Reports" ? "scroll-table" : ""} style={{ marginTop: "17px" }}>
          <Table aria-label="collapsible table" style={{ width: "100%" }}>
            <TableHead className="main-table__header sticky-table-header">
              <ReportHeadRow>
                {toggle == "Financial Reports" ? null : (
                  <TableCell
                    align="left"
                    className="main-check"
                    padding="checkbox"
                  ></TableCell>
                )}
                <TableCell align="left">
                  <SpanHeader>{"segment Name".toLocaleUpperCase()}</SpanHeader>
                  {toggle == "Financial Reports" ? null : (
                    <SortSvg
                      onClick={sortReport}
                      style={{
                        transform: filters?.sort?.name === -1 ? "scaleY(-1)" : "none",
                        transition: "transform 0.2s",
                      }}
                    />
                  )}
                </TableCell>
                <TableCell align="left">
                  <SpanHeader>LAST EXECUTED</SpanHeader>
                </TableCell>

                {toggle !== "Financial Reports" ? (
                  <TableCell align="left">
                    <SpanHeader>{"by".toLocaleUpperCase()}</SpanHeader>
                  </TableCell>
                ) : (
                  ""
                )}

                  {toggle == "Financial Reports" ? null : (
                  <TableCell align="left">
                    <SpanHeader style={{ display: 'flex', alignItems: 'center' }}>
                      {"public".toLocaleUpperCase()}
                      <InfoTooltip text="Checking this makes the segment visible to every user in the organization instead of only you." placement="bottom" useFixed style={{ marginLeft: '6px' }} />
                    </SpanHeader>
                  </TableCell>
                )}
                <TableCell align="left" className="sticky-header-column"></TableCell>
              </ReportHeadRow>
            </TableHead>
            {toggle !== "Financial Reports" ? (
              <TableBody>
                {data && data?.length === 0 && (
                  <ReportTableRow>
                    <TableCell colSpan={6} align="center" style={{ padding: "40px 0", color: "#9a9a9a", fontSize: 14 }}>
                      No data found
                    </TableCell>
                  </ReportTableRow>
                )}
                {data &&
                  data?.length > 0 &&
                  data?.map((item) => (
                    <ReportTableRow
                      className={toggle == "Financial Reports" ? "pointer" : ""}
                    >
                      <TableCell
                        align="left"
                        className="main-check"
                        padding="normal"
                      >
                        {item.is_favourite ? (
                          <FaveTrueSvg
                            onClick={() => {
                              onFave(item._id, false);
                              setId(item._id);
                            }}
                          />
                        ) : (
                          <FaveFalseSvg
                            onClick={() => {
                              onFave(item._id, true);
                              setId(item._id);
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell align="left">
                        <SpanReport>
                          <SpanNameReport>
                            {item?.filterName}
                            <span>{item?.description}</span>
                          </SpanNameReport>
                          <ReportButton
                            type="button"
                            onClick={() => {}}
                            className={`btn btn-secondary font-weight-bold m-2  ml-8`}
                          >
                            {item?.selectedFields[0]?.collectionName}
                          </ReportButton>
                        </SpanReport>
                      </TableCell>
                      <TableCell align="left" padding="default">
                        <TimeWrap>
                          <SpanReport>
                            {formatDate({date:item?.updatedAt, formatType: "defaultWithUTC"})}
                          </SpanReport>
                        </TimeWrap>
                      </TableCell>
                      <TableCell align="left" padding="normal">
                        <SpanReport>
                          {item?.organization?.orgName
                            ? item?.organization?.orgName
                            : "-"}
                        </SpanReport>
                      </TableCell>
                      <TableCell padding="checkbox">
                        {publicLoading && selectedId === item._id ? (
                          // <CircularProgress size={13} />
                          <Checkbox
                            name={item.name}
                            color="primary"
                            checked={false}
                            value={item._id}
                            onChange={(e) => {
                              onChange(e);
                              setId(item._id);
                            }}
                          />
                        ) : (
                          <Checkbox
                            name={item.name}
                            color="primary"
                            checked={item?.is_public ? item?.is_public : false}
                            value={item._id}
                            onChange={(e) => {
                              onChange(e);
                              setId(item._id);
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell  className="sticky-body-column">
                        <div style={{ cursor: "pointer", paddingleft: "0px" }}>
                          <Action
                            style={{ width: "16px" }}
                            action={"report"}
                            deleteFilter={deleteFilter}
                            item={item}
                            setDuolicatetModal={setDuolicatetModal}
                            setDuolicatetData={setDuolicatetData}
                            generateExcelReport={(id) => {
                              handleDownload(id);
                            }}
                            handleDownloadPdf={handleDownloadPdf}
                          />
                        </div>
                      </TableCell>
                    </ReportTableRow>
                  ))}
              </TableBody>
            ) : (
              <TableBody>
                {financialReports !== undefined && financialReports?.length === 0 && (
                  <ReportTableRow>
                    <TableCell colSpan={3} align="center" style={{ padding: "40px 0", color: "#9a9a9a", fontSize: 14 }}>
                      No data found
                    </TableCell>
                  </ReportTableRow>
                )}
                {financialReports !== undefined &&
                  financialReports?.length > 0 &&
                  financialReports?.map((item, index) => {
                    return (
                      <ReportTableRow>
                        <TableCell align="left">
                          <SpanReport>
                            <SpanNameReport>{item?.filterName}</SpanNameReport>
                          </SpanReport>
                        </TableCell>
                        <TableCell align="left" padding="default">
                          <TimeWrap>
                            <SpanReport>
                              {formatDate({date:item?.updatedAt, formatType: "defaultWithUTC"})}
                            </SpanReport>
                          </TimeWrap>
                        </TableCell>

                        <TableCell>
                           <Button
                            size="md"
                            variant="primary"
                            onClick={()=>handleRunReport(item._id, index,item?.filterName)}
                          >
                            <span>Run Report</span>
                          </Button>
                        </TableCell>
                      </ReportTableRow>
                    );
                  })}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      )}
      <div style={{ display: "none" }}>
        {Data?.length > 0 && ComponentToPrint()}
      </div>

      {isLoading && data?.length === 0 ? (
        ""
      ) : toggle == "Financial Reports" ? null : (
        <div className="pagination-custom mt-2">
          <Pagination
            count={Math.ceil(count / 30)}
            color="primary"
            page={page + 1}
            variant="outlined"
            onChange={handleChangePage}
          />
        </div>
      )}

      <>
        <NewDialog isOpen={openReport}  
        title={reportTitle()}
        handleClose={closeModal}
        sx={{ '& .MuiDialog-paperWidthSm': { minWidth: "862px", height: "64%" } }}
        content={
      <>
       <Report
          setOpenReport={(val) => { setOpenReport(val); if (!val) getFinancialList(); }}
          closeModal={closeModal}
          reportName={reportName}
          type={reportType}
          reportIndex={reportIndex}
        />
      </>
       }
        contentStyle={{ display: 'flex', justifyContent: 'center', height: '100%' }}
        buttonStyle={{ justifyContent: 'right' }}
      >
      </NewDialog>
      </>
       <AlertDialog
        open={confirmClose}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </Box>
  );
};
